import { getFormattedPhone } from '../../lib/data/formatters/phone'
import { maskedTextFieldFactory } from '../maskedTextFieldFactory'

export const PhoneTextField = maskedTextFieldFactory(getFormattedPhone)